import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";

// Single source of truth for the drink-spiking "North Star" statement. Fetched once, shared by every node on the site.
export const NORTH_STAR_DEFAULT = {
  eyebrow: "The North Star Guide",
  headline: "Drink Spiking is real - KNOW ABOUT IT.",
  quote: "The worst hangovers aren't always hangovers.",
  subhead: "This Happens Everywhere — Know the Signs",
  body: "1+ in 10 (*very conservatively*) have their drinks spiked: The symptoms are often confused with \"having too much to drink,\" a bad hangover, the flu, etc. & the people who do it know exactly what they are doing - YOU should too. LEARN THE SIGNS & share with friends. You might save their life.",
  cta_label: "Know the Signs — See the North Star Guide →",
  cta_route: "/safety",
  band_bumper: "Drink-spiking is REAL — find resources on THE WALL. Real solutions to real issues in the scene.",
};

let cache = null;
let inflight = null;
const listeners = new Set();

export const setNorthStarCache = (node) => {
  cache = { ...NORTH_STAR_DEFAULT, ...node };
  listeners.forEach((fn) => fn(cache));
};

export const useNorthStar = () => {
  const [node, setNode] = useState(cache || NORTH_STAR_DEFAULT);
  useEffect(() => {
    listeners.add(setNode);
    if (cache) setNode(cache);
    else {
      inflight = inflight || axios.get(`${API}/north-star`).then((r) => { cache = { ...NORTH_STAR_DEFAULT, ...r.data }; return cache; }).catch(() => NORTH_STAR_DEFAULT);
      inflight.then((n) => listeners.forEach((fn) => fn(n)));
    }
    return () => listeners.delete(setNode);
  }, []);
  return node;
};

// Site-wide section layout of the North Star guide card (order / collapsed / teaser). null until loaded.
let guideCache = null;
let guideInflight = null;
const guideListeners = new Set();

export const setNorthStarGuideCache = (sections) => {
  guideCache = sections;
  guideListeners.forEach((fn) => fn(sections));
};

export const useNorthStarGuide = () => {
  const [sections, setSections] = useState(guideCache);
  useEffect(() => {
    guideListeners.add(setSections);
    if (guideCache) setSections(guideCache);
    else {
      guideInflight = guideInflight || axios.get(`${API}/north-star-guide`).then((r) => { guideCache = r.data.sections || []; return guideCache; }).catch(() => { guideCache = []; return guideCache; });
      guideInflight.then((s) => guideListeners.forEach((fn) => fn(s)));
    }
    return () => guideListeners.delete(setSections);
  }, []);
  return sections;
};
